var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.433,
    height: 13.206,
    viewBox: "0 0 9.433 13.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location",
    transform: "translate(-113.076)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_325",
    "data-name": "Ellipse 325",
    cx: 0.804,
    cy: 0.804,
    r: 0.804,
    transform: "translate(117.153 4.074)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17725",
    "data-name": "Path 17725",
    d: "M4.717,0A4.622,4.622,0,0,0,0,4.51,10.514,10.514,0,0,0,1.6,9.191a34.586,34.586,0,0,0,2.358,3.632.936.936,0,0,0,1.51,0A34.73,34.73,0,0,0,7.831,9.191a10.525,10.525,0,0,0,1.6-4.681A4.622,4.622,0,0,0,4.717,0Zm0,6.6A1.887,1.887,0,1,1,6.6,4.717,1.887,1.887,0,0,1,4.717,6.6Z",
    transform: "translate(113.076)",
    fill: "#ffffff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationWhite);
export default __webpack_public_path__ + "static/media/location-white.83c8fc4d48d115b3702f86372490804f.svg";
export { ForwardRef as ReactComponent };